export default __webpack_public_path__ + "static/media/fzrq.2299df6e.jpg";